const HandleNext = (state = false, action) => {
  switch (action.type) {
    case "next":
      state = action.payload;
      return state;
    default:
      return state;
  }
};
export default HandleNext;
